interface BillingDocumentChangeFlags {
  hasFinancialChanges?: boolean;
  hasCosmeticChanges?: boolean;
}

export const billingDocumentHasChangesToReject = (
  billingDocument: BillingDocumentChangeFlags,
): boolean =>
  Boolean(
    billingDocument.hasFinancialChanges || billingDocument.hasCosmeticChanges,
  );
